import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoDetalhe, RootDetailNotification } from '../../../../models/notificacao/notificacao-detalhe.model';
import { LoadingService } from '../../../../util/loader.service';
import { NotificacaoService } from '../notificacao.service';

@Component({
  selector: 'app-notificacao-detalhe',
  templateUrl: './notificacao-detalhe.component.html',
  styleUrls: ['./notificacao-detalhe.component.scss']
})
export class NotificacaoDetalheComponent implements OnInit {
  id: any;

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    descricao: "",
    ativo: true,
  };
  record: RootDetailNotification
  edicao: boolean = false;
  selected = [];
  rows: Object[] = [];
  mesagensGrid = {
    'emptyMessage': 'Nenhum dado para exibir',
    'totalMessage': 'Total de registros',
    'selectedMessage': 'Selecionado'
  };
  registroSelecao = [];
  constructor(public service: NotificacaoService, private route: ActivatedRoute, private routerNavigate: Router, public loader: LoadingService) {
    this.record = new RootDetailNotification()
    this.id = this.route.snapshot.paramMap.get("id");
    this.loader.show("body");
    this.service.ObterInformacoes(this.page, this.id).subscribe(itens => {

      this.record = itens as RootDetailNotification;
      if (itens.dados != null) {
        this.page.count = itens.dados.count;
        this.rows = itens.dados.rows;
        //this.rows = [...this.rows];
      }
      this.loader.hide("body");
    });
  }

  ngOnInit() {
  }
  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.service.ObterInformacoes(this.page, this.id).subscribe(itens => {

      this.record = itens as RootDetailNotification;
      if (itens.dados != null) {
        this.page.count = itens.dados.count;
        this.rows = itens.data.rows;
      }
      this.loader.hide("body");
    });
  }
  onSelect(event) {
    let itens = event.selected;

    let itensSemduplicacao = itens.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null));

    let itemSerRemovido = this.pegarDiferenca(itens, itensSemduplicacao);
    try {
      itens = this.removerItem(itensSemduplicacao, itemSerRemovido);
    } catch (error) {
      //ignore, tudo certo
    }
    this.selected = itens;
    event.selected = itens;

    if (event.selected.length > 0) {
      this.registroSelecao = event.selected;

    } else {

    }
  }
  marcarCheck(codigo) {
    let x = false;
    this.selected.forEach(item => {
      if (item.codigo == codigo) {
        x = true;
      }
    });
    return x;
  }

  removeItemDuplicado(array) {
    array.filter(function (a) {
      return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
    }, Object.create(null))
    return array;
  }

  removerItem(array, item) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].codigo == item[0].codigo) {
        array.splice(i, 1);
      }
    }

    return array;
  }

  pegarDiferenca(r1, r2) {
    let r3 = r1.filter(a => !r2.includes(a));
    return (r3);
  }

}
